"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'detailUser',
  props: {
    userNo: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      dialogUserDetail: false,
      userDetailData: {},
      tabsVal: '1',
      balanceRecordData: [],
      brokerageRecordData: [],
      experienceRecordData: [],
      integralRecordData: [],
      signRecordData: [],
      paginationData: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  watch: {
    tabsVal: function tabsVal(val) {
      this.paginationData.page = 1;
      this.getList(val);
    }
  },
  methods: {
    getList: function getList(val) {
      switch (val) {
        case '2':
          this.getBalabceRecord();
          break;
        case '3':
          this.getBrokerageRecord();
          break;
        case '4':
          this.getExperienceRecord();
          break;
        case '5':
          this.getIntegralRecord();
          break;
        case '6':
          this.getSignRecord();
          break;
      }
    },
    //获取签到记录列表
    getSignRecord: function getSignRecord() {
      var _this = this;
      (0, _user.userSignRecord)({
        userId: this.userDetailData.id,
        page: this.paginationData.page,
        limit: this.paginationData.limit
      }).then(function (res) {
        _this.signRecordData = res.list;
        _this.paginationData.total = res.total;
      });
    },
    //获取积分记录列表
    getIntegralRecord: function getIntegralRecord() {
      var _this2 = this;
      (0, _user.userIntegralRecord)({
        userId: this.userDetailData.id,
        page: this.paginationData.page,
        limit: this.paginationData.limit
      }).then(function (res) {
        _this2.integralRecordData = res.list;
        _this2.paginationData.total = res.total;
      });
    },
    //获取经验记录列表
    getExperienceRecord: function getExperienceRecord() {
      var _this3 = this;
      (0, _user.userExperienceRecord)({
        userId: this.userDetailData.id,
        page: this.paginationData.page,
        limit: this.paginationData.limit
      }).then(function (res) {
        _this3.experienceRecordData = res.list;
        _this3.paginationData.total = res.total;
      });
    },
    //获取佣金记录列表
    getBrokerageRecord: function getBrokerageRecord() {
      var _this4 = this;
      (0, _user.userBrokerageRecord)({
        userId: this.userDetailData.id,
        page: this.paginationData.page,
        limit: this.paginationData.limit
      }).then(function (res) {
        _this4.brokerageRecordData = res.list;
        _this4.paginationData.total = res.total;
      });
    },
    //获取余额记录列表
    getBalabceRecord: function getBalabceRecord() {
      var _this5 = this;
      (0, _user.userBalanceRecord)({
        userId: this.userDetailData.id,
        page: this.paginationData.page,
        limit: this.paginationData.limit
      }).then(function (res) {
        _this5.balanceRecordData = res.list;
        _this5.paginationData.total = res.total;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.paginationData.limit = val;
      this.getList(this.tabsVal);
    },
    pageChange: function pageChange(val) {
      this.paginationData.page = val;
      this.getList(this.tabsVal);
    },
    handleClose: function handleClose() {
      this.dialogUserDetail = false;
      this.tabsVal = '1';
    },
    getUserDetail: function getUserDetail(id) {
      var _this6 = this;
      (0, _user.userDetailApi)(id).then(function (res) {
        _this6.userDetailData = res;
      });
    }
  }
};